import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { Html5Qrcode } from "html5-qrcode";

const ELEMENT_ID = "wallet-check-qr-camera";

/**
 * Live camera QR scanner (mobile-first). Calls onDecode(text) once a QR is read.
 * Requires HTTPS or localhost for camera access.
 */
const QrScanner = ({ onDecode, onError }) => {
  const scannerRef = useRef(null);
  const handledRef = useRef(false);

  useEffect(() => {
    const scanner = new Html5Qrcode(ELEMENT_ID, { verbose: false });
    scannerRef.current = scanner;
    handledRef.current = false;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 240, height: 240 } },
        (decodedText) => {
          if (handledRef.current) return;
          handledRef.current = true;
          onDecode?.(decodedText);
        },
        () => {
          /* ignore per-frame decode errors */
        }
      )
      .catch((err) => {
        onError?.(err);
      });

    return () => {
      const s = scannerRef.current;
      if (!s) return;
      s.stop()
        .then(() => s.clear())
        .catch(() => {
          try {
            s.clear();
          } catch (_) {
            /* noop */
          }
        });
    };
  }, [onDecode, onError]);

  return (
    <Box>
      <Box
        id={ELEMENT_ID}
        sx={{
          width: "100%",
          borderRadius: 2,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.15)",
          "& video": { width: "100% !important", borderRadius: 8 },
        }}
      />
      <Typography
        variant="caption"
        sx={{ color: "rgba(255,255,255,0.55)", display: "block", mt: 1, textAlign: "center" }}
      >
        Point the camera at the client's wallet QR code
      </Typography>
    </Box>
  );
};

export default QrScanner;
